module.exports = __webpack_public_path__ + "img/安平丝网与养猪2.2bce4fc5.jpg";